import React from 'react';
import { Container, Card, CardBody, CardTitle, CardText } from 'reactstrap';

const UserNotFound = () => {
  return (
    <Container className="mt-3">
      <Card>
        <CardBody>
          <CardTitle className="lead">
            Sorry! We can't find your account
          </CardTitle>
          <hr />
          <CardText>
            It seems we can't find your account, please contact your
            Administrator to esure that have access to this website
          </CardText>
        </CardBody>
      </Card>
    </Container>
  );
};
export default UserNotFound;
